var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 0.5C16.0005 0.223858 15.7766 0 15.5005 0H11.2076C10.7621 0 10.539 0.538571 10.854 0.853553L12.2935 2.293L6.02246 8.564L7.43646 9.978L13.7075 3.707L15.1469 5.14645C15.4619 5.46143 16.0005 5.23835 16.0005 4.79289V0.5Z",
    fill: "#282D37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H1C0.448 16 0 15.552 0 15V3C0 2.448 0.448 2 1 2H6C6.55228 2 7 2.44772 7 3V3C7 3.55228 6.55228 4 6 4H2V14H12V10C12 9.44772 12.4477 9 13 9V9C13.5523 9 14 9.44772 14 10V15C14 15.552 13.552 16 13 16Z",
    fill: "#282D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.a75b3374b5f775a9d5a25f91cef4f79d.svg";
export { ForwardRef as ReactComponent };